import { useEffect, useState, useContext } from 'react'
import axiosConfig from 'utils/axiosConfig'
import MenuButton from 'containers/Examination/Components/MenuButton'
import { TableContainer, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { getUserClassrooms } from 'containers/Examination/ExaminationService'
import { v4 as uuid } from 'uuid'
import { StateContext } from 'context/Provider'

import './ExaminationTable.css'
import 'containers/Examination/Examination.css'

const ExaminationTable = () => {

  const appState = useContext(StateContext)
  const { authState } = appState

  const [examinations, setExaminations] = useState([])
  const [classrooms, setClassrooms] = useState([])
  const [stateToggle, setStateToggle] = useState(null)

  const getExams = () => {
    axiosConfig.get(`examinations`).then((response) => {
      let responseBody = response.data

      if (!responseBody.success) {
        console.log(responseBody.message)
      }

      setExaminations(response.data.examinations)
    })
  }

  const getClassroomList = async () => {
    let classrooms = await getUserClassrooms()
    setClassrooms(classrooms)
  }

  useEffect(() => {
    getExams()
    getClassroomList()
  }, [stateToggle])

  return (
    <TableContainer component="table">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Classroom</TableCell>
          {authState.user.school_id === 29 && authState.user.role_id === 3 && <TableCell>Author</TableCell>}
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {examinations.length > 0 && examinations.map((exam) => (
          <TableRow key={exam.id}>
            <TableCell>{exam.name}</TableCell>
            <TableCell>{exam.classroom.name}</TableCell>
            {authState.user.school_id === 29 && authState.user.role_id === 3 &&
              <TableCell>
                {exam.author.name}
              </TableCell>
            }
            <TableCell style={{display: 'flex', justifyContent: 'end', gap: '5px'}}>
              <MenuButton exam={exam} classrooms={classrooms} refreshExams={() => setStateToggle(uuid())} />
            </TableCell>
          </TableRow>
        ))}
        {examinations.length <= 0 &&
          (
            <TableRow>
              <TableCell colSpan={6} style={{textAlign: 'center', fontStyle: 'italic'}}>No data found</TableCell>
            </TableRow>
          )
        }
      </TableBody>
    </TableContainer>
  )
}

export default ExaminationTable;